import { HIDE_DIALOG } from '../constants/action-types';
export const hide = () => ({
    type: HIDE_DIALOG,
});
